/**
 * 
 * @param {string} char 
 */
function isVowel (char)
{
    switch (char.substr(0, 1).toLowerCase())
    {
        case 'a':
        case 'e':
        case 'i':
        case 'o':
        case 'u':
        case 'y':
            return true
        default:
            return false
    }
}

/**
 * 
 * @param {string} str 
 * @param {number} number 
 */
function plural (str, number)
{
    if (Array.isArray(number)) number = number.length
    if (typeof number == 'string') number = Number.parseFloat(number)

    return str + (number > 1 ? 's' : '')
}

export default { isVowel, plural }


// WEBPACK FOOTER //
// ./src/utils/grammarUtils.js